import { Control, FieldValues, UseFormReturn } from "react-hook-form";
import { FormField, FormSchema } from "./DynamicFormTypes";
import { Stack, Typography } from "@mui/material";
import TextFieldInput from "./formElements/TextFieldInput";
import SelectInput from "./formElements/SelectInput";
import TextAreaInput from "./formElements/TextAreaInput";
import RadioInput from "./formElements/RadioInput";
import CheckboxInput from "./formElements/CheckboxInput";

type FormBuilderProps = {
    form: UseFormReturn;
    schema: FormSchema;
}

const DynamicForm = ({ form, schema }: FormBuilderProps) => {
    const title = schema.title;

    const renderFormField = (
        field: FormField,
    ) => {
        const type = field.type;
        switch(type) {
        case "text":
        case "url":
        case "email":
        case "password":
            return <TextFieldInput key={field.name} field={field} form={form} />;
        case "textarea":
            return <TextAreaInput key={field.name} field={field} form={form} />;
        case "select":
            return <SelectInput key={field.name} field={field} form={form} />;
        case "radio":
            return <RadioInput key={field.name} field={field} form={form} />;
        case "checkbox":
            return <CheckboxInput key={field.name} field={field} form={form} />
        default:
            return <></>
        }
    }

    const renderForm = (
        control: Control<FieldValues>,
        schema: FormSchema,
    ) => {
        return schema.fields.map((field: FormField) => renderFormField(field));
    }

    return(<Stack alignItems="flex-start" spacing={"40px"} marginY={3}>
        <Typography fontWeight={600} fontSize={"24px"} variant={"h2"}>{title}</Typography>
        {renderForm(form.control, schema)}
    </Stack>
    )
}


export default DynamicForm;